import moment from 'moment';
import { window } from 'global';

export const STORE_REDIRECT_VALUES = 'STORE_REDIRECT_VALUES';
export const REDIRECT_FROM_STORAGE = 'REDIRECT_FROM_STORAGE';
export const CLEAR_REDIRECT_FROM_STORAGE = 'CLEAR_REDIRECT_FROM_STORAGE';

export function storeRedirectValues({
  url = window.location.href.replace(window.location.origin, ''),
  timeout = moment().add(1, 'day').valueOf(),
  preserveUrlParams = false,
} = {}) {
  return {
    type: STORE_REDIRECT_VALUES,
    payload: {
      url,
      timeout,
      preserveUrlParams,
    },
  };
}

export function redirectFromStorage() {
  return {
    type: REDIRECT_FROM_STORAGE,
  };
}

export function clearRedirectFromStorage() {
  return {
    type: CLEAR_REDIRECT_FROM_STORAGE,
  };
}



// WEBPACK FOOTER //
// ./src/actions/redirect.js